import EventEmmiter from '../../helpers/EventEmmiter';

require('./tips.scss');

export default class E3Tips extends EventEmmiter {
    _tips = {};
    _step = {};
    _currentStep = null;
    _stepImage = {};
    _stepText = {};
    _stepClose = {};
    _actions = {};
    _steps = {};
    _enabled = true;
    _isShowed = false;

    constructor(container, opt) {
        super();
        this._container = container;
        ({steps: this._steps} = opt);

        this._init();
    }

    _bindActions(actions = {}){
        this._actions['close'] = {
            element: this._stepClose,
            events: ['click'],
            handlers: [this._stepCloseHandler.bind(this)]
        };

        if (actions) {
            for (let a in actions) {
                if (actions.hasOwnProperty(a)) {
                    this._actions[a] = {
                        element: actions[a].element,
                        events: actions[a].events,
                        handlers: actions[a].handlers,
                    }
                }
            }
        }

        for (let a in this._actions) {
            if (this._actions.hasOwnProperty(a)) {
                let {events, handlers} = this._actions[a];

                events.forEach((event, i) => {
                    this._actions[a].element.addEventListener(event, handlers[i]);
                })
            }
        }
    }

    _init() {
        let firstChild = this._container.firstChild;

        this._tips = document.createElement('div');
        this._tips.classList.add('e3-tips');

        this._initStep();

        if (firstChild) {
            this._container.insertBefore(this._tips, firstChild);
        } else {
            this._container.appendChild(this._tips);
        }

        this._bindActions();
    }

    _initStep() {
        this._stepImage = document.createElement('img');
        this._stepText = document.createElement('p');
        this._stepClose = document.createElement('button');
        this._stepClose.classList.add('close-step');

        this._step = document.createElement('div');
        this._step.classList.add('e3-tips__step', 'hide-step');

        this._step.appendChild(this._stepImage);
        this._step.appendChild(this._stepText);
        this._step.appendChild(this._stepClose);

        this._tips.appendChild(this._step);

        // this._setStep(Object.keys(this._steps)[0]);
    }

    _setStep(key) {
        this._currentStep = this._steps[key];

        if (!this._currentStep) return;

        let {img, text} = this._currentStep;

        this._stepImage.src = img;
        this._stepText.innerText = text;

        if (this._enabled && this._currentStep) this._step.classList.remove('hide-step');

    }

    _stepCloseHandler(e) {
        e.preventDefault();

        this._step.classList.add('hide-step');
    }

    _unbindActions() {
        for (let a in this._actions) {
            if (this._actions.hasOwnProperty(a)) {
                let {events, handlers} = this._actions[a];

                events.forEach((event, i) => {
                    this._actions[a].element.removeEventListener(event, handlers[i]);
                })
            }
        }
    }

    changeStep(key) {
        if(!this._isShowed){
            this._setStep(key);
            this._isShowed = !this._isShowed;
        }
    }

    cleanUpStep() {
        this._currentStep = null;
        this._step.classList.add('hide-step');
    }


    // todo: destroy instance events
    destroy() {
        this._unbindActions();
    }

    toggle(show) {
        if (!this._enabled || !this._currentStep) return;

        switch (show) {
            case true:
                this._step.classList.remove('hide-step');
                break;
            case false:
                this._isShowed = false;
                this._step.classList.add('hide-step');
                break;
            default:
                this._step.classList.toggle('hide-step');
        }
    }

    toggleAvailability() {
        this._enabled = !this._enabled;
        this._step.classList[this._enabled ? 'remove' : 'add']('hide-step');
    }
}
